module.exports = __webpack_public_path__ + "static/media/19_A.c29080df.png";